export default "__VITE_ASSET__Cmbs60jG__"